import { observer } from 'mobx-react-lite';
import { Pressable, View } from 'react-native';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { styles } from './Toast.styles';
import { brand, neutrals } from 'src/theme/colors';
import { Icon } from '../icon/Icon';
import { ICON_NAMES } from '../icon/icon.helper';
import { toastNotificationTestID } from 'src/helpers/testIDs.helper';
import { TOAST_TYPES } from 'src/store/toast/toastStore.types';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';
import { TextIconButton } from '../buttons/text-icon-button/TextIconButton';
import { TEXT_ICON_BUTTON_SIZES, TEXT_ICON_BUTTON_TYPES } from '../buttons/text-icon-button/TextIconButton.constants';
import TextLato from '../text/text-lato/TextLato';
import Spinner from '../spinner/Spinner';
import { AnimatedIcon } from '../animated-icon/AnimatedIcon';
import { ToastContentProps } from './ToastContent.types';

export const ToastContent = observer(
  ({
    id,
    index,
    icon,
    iconColor,
    message,
    ctaText,
    onPress,
    group,
    type,
    loader,
    ctaIconType = TEXT_ICON_BUTTON_TYPES.ICON_RIGHT,
    ctaIconName = ICON_NAMES.ArrowRight1,
    onPressClose,
    filled = false,
    animatedIcon,
    isAnimatedIconVisible = false,
  }: ToastContentProps) => {
    const { isMobile } = useResponsiveScreen();

    return (
      <View
        style={[styles.alertToastContainer, isMobile && styles.alertToastContainerMobile]}
        testID={toastNotificationTestID(group)}
      >
        {loader && <Spinner height={22} width={22} />}
        {icon && (
          <View style={styles.iconToast}>
            <Icon
              name={icon as ICON_NAMES}
              color={iconColor ?? brand.main.orange}
              width={20}
              height={20}
              filled={filled}
            />
          </View>
        )}
        {animatedIcon && <AnimatedIcon name={animatedIcon} isVisible={isAnimatedIconVisible} />}
        <TextLato
          style={[
            isMobile ? { ...styles.alertText, ...styles.alertTextMobile } : styles.alertText,
            type === TOAST_TYPES.Error ? styles.ctaTextError : {},
          ]}
          numberOfLines={3}
          ellipsizeMode="tail"
        >
          {message}
        </TextLato>
        {ctaText && onPress && (
          <TextIconButton
            style={styles.ctaContainer}
            innerStyle={styles.ctaInnerContainer}
            focusStyle={styles.ctaContainerFocus}
            onPress={async () => onPress()}
            text={ctaText}
            textStyle={styles.ctaText}
            focusId={toastNotificationTestID(group, id)}
            testID={toastNotificationTestID(group, id)}
            focusOrder={index}
            focusGroup={FocusGroups.TOAST_NOTIFICATION}
            accessible={true}
            accessibilityLabel={ctaText}
            accessibilityRole="button"
            size={TEXT_ICON_BUTTON_SIZES.SMALL}
            type={ctaIconType}
            iconName={ctaIconName}
            iconStyle={styles.icon}
          />
        )}
        {onPressClose && (
          <Pressable style={styles.ctaClose} onPress={async () => onPressClose()}>
            <Icon name={ICON_NAMES.Close} width={14} height={14} color={neutrals.neutralGrays.graphite} />
          </Pressable>
        )}
      </View>
    );
  },
);
